import { NAV_CONTEXT } from './state'

const context = (state) => state.context

const isClienteContext = (state) => state.context === NAV_CONTEXT.CLIENTE

// Cliente pelo qual os módulos devem pré-filtrar quando estamos na visão de um
// cliente específico. Retorna null na visão de gestão (traz tudo) — e como o
// contexto só vira 'cliente' na navegação 2026, é naturalmente seguro no v1.
const clientePreFiltro = (state, getters, rootState, rootGetters) => {
  if (state.context !== NAV_CONTEXT.CLIENTE) return null
  return rootGetters['user/currentClient'] || null
}

export default { context, isClienteContext, clientePreFiltro }
